var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["macros/render-promo-entry.j2"] = require( "macros/render-promo-entry.j2" );
dependencies["macros/contentful/navigation-treatment-macro.j2"] = require( "macros/contentful/navigation-treatment-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/super-navigation-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/super-navigation-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/super-navigation-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderNavItem")) {
var t_8 = t_5.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_8);
output += "\n";
env.getTemplate("macros/render-promo-entry.j2", false, "core/templates/macros/super-navigation-macro.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("renderPromo")) {
var t_12 = t_9.renderPromo;
} else {
cb(new Error("cannot import 'renderPromo'")); return;
}
context.setVariable("renderPromo", t_12);
output += "\n";
env.getTemplate("macros/contentful/navigation-treatment-macro.j2", false, "core/templates/macros/super-navigation-macro.j2", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
t_13.getExported(function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
if(t_13.hasOwnProperty("generateTreatmentStyles")) {
var t_16 = t_13.generateTreatmentStyles;
} else {
cb(new Error("cannot import 'generateTreatmentStyles'")); return;
}
context.setVariable("generateTreatmentStyles", t_16);
var macro_t_17 = runtime.makeMacro(
["slugs"], 
["tertiaryLimit", "seeMore", "superNav", "level", "levelLimit", "selectedLevel1Slug", "class", "inContainer"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("tertiaryLimit", kwargs.hasOwnProperty("tertiaryLimit") ? kwargs["tertiaryLimit"] : 0);
frame.set("seeMore", kwargs.hasOwnProperty("seeMore") ? kwargs["seeMore"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("superNav", kwargs.hasOwnProperty("superNav") ? kwargs["superNav"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 1);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("selectedLevel1Slug", kwargs.hasOwnProperty("selectedLevel1Slug") ? kwargs["selectedLevel1Slug"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("inContainer", kwargs.hasOwnProperty("inContainer") ? kwargs["inContainer"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_18 = "";t_18 += "\n\n    ";
t_18 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_18 += "\n\n        ";
var t_19;
t_19 = ((runtime.contextOrFrameLookup(context, frame, "level") == 1)?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("islevelOne", t_19, true);
if(frame.topLevel) {
context.setVariable("islevelOne", t_19);
}
if(frame.topLevel) {
context.addExport("islevelOne", t_19);
}
t_18 += "\n        ";
var t_20;
t_20 = (lineno = 40, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.navigationTreatmentContainer",[]]));
frame.set("navigationTreatments", t_20, true);
if(frame.topLevel) {
context.setVariable("navigationTreatments", t_20);
}
if(frame.topLevel) {
context.addExport("navigationTreatments", t_20);
}
t_18 += "\n        ";
var t_21;
t_21 = (runtime.contextOrFrameLookup(context, frame, "islevelOne") && !runtime.contextOrFrameLookup(context, frame, "hasLargeHideClass") && env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "navigationTreatments")) > 0?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("treatmentsAvailable", t_21, true);
if(frame.topLevel) {
context.setVariable("treatmentsAvailable", t_21);
}
if(frame.topLevel) {
context.addExport("treatmentsAvailable", t_21);
}
t_18 += "\n        ";
var t_22;
t_22 = (runtime.contextOrFrameLookup(context, frame, "treatmentsAvailable")?"navigation-treatment-":"");
frame.set("idPrefix", t_22, true);
if(frame.topLevel) {
context.setVariable("idPrefix", t_22);
}
if(frame.topLevel) {
context.addExport("idPrefix", t_22);
}
t_18 += "\n\n        ";
t_18 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "treatmentsAvailable")?(lineno = 44, colno = 32, runtime.callWrap(t_16, "generateTreatmentStyles", context, [runtime.contextOrFrameLookup(context, frame, "idPrefix"),runtime.contextOrFrameLookup(context, frame, "navigationTreatments")])):""), env.opts.autoescape);
t_18 += "\n\n        <ul class=\"";
t_18 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_18 += " ";
t_18 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_18 += "-";
t_18 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_18 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_18 += "itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\"";
;
}
t_18 += " data-qa-main-navigation>\n\n        ";
frame = frame.push();
var t_25 = l_slugs;
if(t_25) {var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("slug", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
t_18 += "\n\n            ";
var t_27;
t_27 = runtime.contextOrFrameLookup(context, frame, "level") < 3 || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") <= runtime.contextOrFrameLookup(context, frame, "tertiaryLimit") && runtime.contextOrFrameLookup(context, frame, "tertiaryLimit") != 0);
frame.set("shouldDisplayTertiary", t_27, true);
if(frame.topLevel) {
context.setVariable("shouldDisplayTertiary", t_27);
}
if(frame.topLevel) {
context.addExport("shouldDisplayTertiary", t_27);
}
t_18 += "\n            ";
var t_28;
t_28 = (runtime.contextOrFrameLookup(context, frame, "treatmentsAvailable") && (lineno = 51, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.navigationTreatmentListing." + "" + t_26]))?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("slugHasTreatment", t_28, true);
if(frame.topLevel) {
context.setVariable("slugHasTreatment", t_28);
}
if(frame.topLevel) {
context.addExport("slugHasTreatment", t_28);
}
t_18 += "\n            ";
var t_29;
t_29 = (runtime.contextOrFrameLookup(context, frame, "slugHasTreatment")?"id=" + "" + runtime.contextOrFrameLookup(context, frame, "idPrefix") + "" + t_26:"");
frame.set("treatmentId", t_29, true);
if(frame.topLevel) {
context.setVariable("treatmentId", t_29);
}
if(frame.topLevel) {
context.addExport("treatmentId", t_29);
}
t_18 += "\n\n            ";
t_18 += "\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_26) && runtime.contextOrFrameLookup(context, frame, "shouldDisplayTertiary")) {
t_18 += "\n\n                ";
var t_30;
t_30 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_26);
frame.set("navItem", t_30, true);
if(frame.topLevel) {
context.setVariable("navItem", t_30);
}
if(frame.topLevel) {
context.addExport("navItem", t_30);
}
t_18 += "\n\n                ";
t_18 += runtime.suppressValue((lineno = 59, colno = 64, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_31 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_32 = "";t_32 += "\n\n                    ";
var t_33;
t_33 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True"))?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_33, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_33);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_33);
}
t_32 += "\n                    ";
var t_34;
t_34 = ((runtime.contextOrFrameLookup(context, frame, "level") == 1) && (t_26 == runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"))?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("displaySelectedState", t_34, true);
if(frame.topLevel) {
context.setVariable("displaySelectedState", t_34);
}
if(frame.topLevel) {
context.addExport("displaySelectedState", t_34);
}
t_32 += "\n                    ";
var t_35;
t_35 = ((runtime.contextOrFrameLookup(context, frame, "level") == 1 && runtime.memberLookup((l_currentNavItem),"typeCode") == "HEADING")?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isHeading", t_35, true);
if(frame.topLevel) {
context.setVariable("isHeading", t_35);
}
if(frame.topLevel) {
context.addExport("isHeading", t_35);
}
t_32 += "\n                    ";
var t_36;
t_36 = "noopener noreferrer";
frame.set("rel", t_36, true);
if(frame.topLevel) {
context.setVariable("rel", t_36);
}
if(frame.topLevel) {
context.addExport("rel", t_36);
}
t_32 += "\n                    ";
var t_37;
t_37 = (runtime.memberLookup((l_currentNavItem),"parentSlug")?runtime.memberLookup((l_currentNavItem),"parentSlug"):runtime.memberLookup((l_currentNavItem),"slug"));
frame.set("rootCategorySlug", t_37, true);
if(frame.topLevel) {
context.setVariable("rootCategorySlug", t_37);
}
if(frame.topLevel) {
context.addExport("rootCategorySlug", t_37);
}
t_32 += "\n\n                    <li class=\"";
t_32 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li", env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li--level-" + "" + runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "inContainer")?"is-feature":""), env.opts.autoescape);
t_32 += " ";
if(runtime.contextOrFrameLookup(context, frame, "level") == 1) {
t_32 += " js-navigation-item js-level1-nav-item ";
;
}
t_32 += " ";
t_32 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "displaySelectedState")?"is-selected":""), env.opts.autoescape);
t_32 += "\" data-slug=\"";
t_32 += runtime.suppressValue(t_26, env.opts.autoescape);
t_32 += "\">\n\n                        ";
var t_38;
t_38 = (lineno = 71, colno = 59, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_38, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_38);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_38);
}
t_32 += "\n                        ";
var t_39;
t_39 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_39, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_39);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_39);
}
t_32 += "\n                        ";
var t_40;
t_40 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isContainer", t_40, true);
if(frame.topLevel) {
context.setVariable("isContainer", t_40);
}
if(frame.topLevel) {
context.addExport("isContainer", t_40);
}
t_32 += "\n\n                        ";
t_32 += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == runtime.contextOrFrameLookup(context, frame, "tertiaryLimit") && runtime.contextOrFrameLookup(context, frame, "level") == 3 && runtime.contextOrFrameLookup(context, frame, "seeMore")) {
t_32 += "\n\n                            <a ";
if(l_target) {
t_32 += "target=\"";
t_32 += runtime.suppressValue(l_target, env.opts.autoescape);
t_32 += "\" ";
if(l_target == "_blank") {
t_32 += " rel=\"";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_32 += "\" ";
;
}
;
}
t_32 += " class=\"";
t_32 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_32 += "-";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_32 += " c-main-navigation__a--see-more\" ";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "treatmentId"), env.opts.autoescape);
t_32 += " href=\"";
t_32 += runtime.suppressValue((lineno = 78, colno = 276, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((l_currentNavItem),"parentSlug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
t_32 += "\">\n\n                                ";
t_32 += runtime.suppressValue((lineno = 80, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["navigation_see-more"])), env.opts.autoescape);
t_32 += "\n\n                            </a>\n\n                        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isContainer") || runtime.contextOrFrameLookup(context, frame, "isHeading")) {
t_32 += "\n\n                            <span class=\"";
t_32 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span--level", env.opts.autoescape);
t_32 += "-";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isContainer")?"is-feature":""), env.opts.autoescape);
t_32 += "\" ";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "treatmentId"), env.opts.autoescape);
t_32 += " >\n\n                                ";
t_32 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_32 += "\n\n                            </span>\n\n                        ";
;
}
else {
t_32 += "\n                            ";
var t_41;
t_41 = (runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0);
frame.set("hasNoChildren", t_41, true);
if(frame.topLevel) {
context.setVariable("hasNoChildren", t_41);
}
if(frame.topLevel) {
context.addExport("hasNoChildren", t_41);
}
t_32 += "\n                            ";
var t_42;
t_42 = "c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a--level-" + "" + runtime.contextOrFrameLookup(context, frame, "level");
frame.set("levelClass", t_42, true);
if(frame.topLevel) {
context.setVariable("levelClass", t_42);
}
if(frame.topLevel) {
context.addExport("levelClass", t_42);
}
t_32 += "\n                            ";
var t_43;
t_43 = (runtime.contextOrFrameLookup(context, frame, "hasNoChildren")?("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a--no-children"):"");
frame.set("noChildrenClass", t_43, true);
if(frame.topLevel) {
context.setVariable("noChildrenClass", t_43);
}
if(frame.topLevel) {
context.addExport("noChildrenClass", t_43);
}
t_32 += "\n                            ";
var t_44;
t_44 = (runtime.contextOrFrameLookup(context, frame, "levelClass") + "" + " " + "" + runtime.contextOrFrameLookup(context, frame, "noChildrenClass"));
frame.set("classList", t_44, true);
if(frame.topLevel) {
context.setVariable("classList", t_44);
}
if(frame.topLevel) {
context.addExport("classList", t_44);
}
t_32 += "\n\n                            <a ";
if(l_target) {
t_32 += "target=\"";
t_32 += runtime.suppressValue(l_target, env.opts.autoescape);
t_32 += "\" ";
if(l_target == "_blank") {
t_32 += " rel=\"";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_32 += "\" ";
;
}
;
}
t_32 += "\n\n                                ";
t_32 += runtime.suppressValue((lineno = 100, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 100, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "treatmentId"), env.opts.autoescape);
t_32 += "\n                                class=\"";
t_32 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_32 += " ";
t_32 += runtime.suppressValue(env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "classList")), env.opts.autoescape);
t_32 += "\" href=\"";
t_32 += runtime.suppressValue(l_url, env.opts.autoescape);
t_32 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_32 += "itemprop=\"url\"";
;
}
t_32 += " data-qa-main-navigation-link>\n\n                                    <span ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_32 += "itemprop=\"name\"";
;
}
t_32 += ">\n\n                                        ";
t_32 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_32 += "\n\n                                    </span>\n\n                            </a>\n\n                        ";
;
}
;
}
t_32 += "\n\n                        ";
t_32 += "\n                        ";
if(runtime.memberLookup((l_currentNavItem),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) > 0) {
t_32 += "\n\n                            ";
t_32 += "\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "level") == 2 && runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"tertiaryDisplay") >= 0) {
t_32 += "\n\n                                ";
var t_45;
t_45 = runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"tertiaryDisplay");
frame.set("tertiaryDisplay", t_45, true);
if(frame.topLevel) {
context.setVariable("tertiaryDisplay", t_45);
}
if(frame.topLevel) {
context.addExport("tertiaryDisplay", t_45);
}
t_32 += "\n                                ";
var t_46;
t_46 = ((lineno = 121, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.showSuperNavL3s",runtime.contextOrFrameLookup(context, frame, "False")]))?runtime.contextOrFrameLookup(context, frame, "tertiaryDisplay"):0);
frame.set("nextLimit", t_46, true);
if(frame.topLevel) {
context.setVariable("nextLimit", t_46);
}
if(frame.topLevel) {
context.addExport("nextLimit", t_46);
}
t_32 += "\n\n                            ";
;
}
else {
t_32 += "\n\n                                ";
var t_47;
t_47 = env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs"));
frame.set("nextLimit", t_47, true);
if(frame.topLevel) {
context.setVariable("nextLimit", t_47);
}
if(frame.topLevel) {
context.addExport("nextLimit", t_47);
}
t_32 += "\n\n                            ";
;
}
t_32 += "\n\n                            ";
t_32 += "\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "superNav")) {
t_32 += "\n\n                                ";
var t_48;
t_48 = (env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"containerInfo"))?runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"containerInfo")),0):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("featureSlug", t_48, true);
if(frame.topLevel) {
context.setVariable("featureSlug", t_48);
}
if(frame.topLevel) {
context.addExport("featureSlug", t_48);
}
t_32 += "\n\n                                ";
t_32 += runtime.suppressValue((lineno = 134, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "superNavigation"), "superNavigation", context, [runtime.memberLookup((l_currentNavItem),"childSlugs"),runtime.contextOrFrameLookup(context, frame, "nextLimit"),runtime.contextOrFrameLookup(context, frame, "seeMore"),runtime.contextOrFrameLookup(context, frame, "level"),t_26,runtime.contextOrFrameLookup(context, frame, "featureSlug"),runtime.makeKeywordArgs({"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_32 += "\n\n                            ";
;
}
else {
t_32 += "\n                                ";
t_32 += "\n                                ";
t_32 += runtime.suppressValue((lineno = 139, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "mainNavigationTree"), "mainNavigationTree", context, [runtime.memberLookup((l_currentNavItem),"childSlugs"),runtime.contextOrFrameLookup(context, frame, "nextLimit"),runtime.contextOrFrameLookup(context, frame, "seeMore"),runtime.contextOrFrameLookup(context, frame, "False"),runtime.makeKeywordArgs({"level": runtime.contextOrFrameLookup(context, frame, "level") + 1,"selectedLevel1Slug": runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),"class": runtime.contextOrFrameLookup(context, frame, "class"),"inContainer": runtime.contextOrFrameLookup(context, frame, "isContainer")})])), env.opts.autoescape);
t_32 += "\n\n                            ";
;
}
t_32 += "\n\n                        ";
;
}
t_32 += "\n\n                    </li>\n\n                ";
;
frame = frame.pop();
return new runtime.SafeString(t_32);
});
return macro_t_31;})()})])), env.opts.autoescape);
t_18 += "\n\n            ";
;
}
t_18 += "\n\n        ";
;
}
}
frame = frame.pop();
t_18 += "\n\n        </ul>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne") && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large"))) {
t_18 += "\n            <span class=\"js-nav-slide-line c-main-navigation__slide-line\"></span>\n        ";
;
}
t_18 += "\n\n    ";
;
}
t_18 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
context.addExport("mainNavigationTree");
context.setVariable("mainNavigationTree", macro_t_17);
var macro_t_49 = runtime.makeMacro(
["slugs", "tertiaryLimit", "seeMore", "level", "parentSlug", "featureSlug"], 
["class"], 
function (l_slugs, l_tertiaryLimit, l_seeMore, l_level, l_parentSlug, l_featureSlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("tertiaryLimit", l_tertiaryLimit);
frame.set("seeMore", l_seeMore);
frame.set("level", l_level);
frame.set("parentSlug", l_parentSlug);
frame.set("featureSlug", l_featureSlug);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_50 = "";t_50 += "\n\n    ";
var t_51;
t_51 = "navigation-" + "" + l_parentSlug;
frame.set("contentfulSlug", t_51, true);
if(frame.topLevel) {
context.setVariable("contentfulSlug", t_51);
}
if(frame.topLevel) {
context.addExport("contentfulSlug", t_51);
}
t_50 += "\n    ";
var t_52;
t_52 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("promoEntry", t_52, true);
if(frame.topLevel) {
context.setVariable("promoEntry", t_52);
}
if(frame.topLevel) {
context.addExport("promoEntry", t_52);
}
t_50 += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"superNavPromos") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"superNavPromos")),runtime.contextOrFrameLookup(context, frame, "contentfulSlug"))) {
t_50 += "\n          ";
var t_53;
t_53 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"superNavPromos")),runtime.contextOrFrameLookup(context, frame, "contentfulSlug"));
frame.set("promoEntry", t_53, true);
if(frame.topLevel) {
context.setVariable("promoEntry", t_53);
}
if(frame.topLevel) {
context.addExport("promoEntry", t_53);
}
t_50 += "\n    ";
;
}
t_50 += "\n\n    ";
var t_54;
t_54 = (runtime.contextOrFrameLookup(context, frame, "promoEntry") || l_featureSlug?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("hasFeatureColumn", t_54, true);
if(frame.topLevel) {
context.setVariable("hasFeatureColumn", t_54);
}
if(frame.topLevel) {
context.addExport("hasFeatureColumn", t_54);
}
t_50 += "\n\n    <div class=\"c-super-navigation js-super-nav\">\n\n        <div class=\"o-row\">\n\n            <div class=\"c-super-navigation__content u-clearfix\">\n\n                <div class=\"o-row g-super-navigation__category-container ";
t_50 += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "hasFeatureColumn")?"has-no-features":""), env.opts.autoescape);
t_50 += "\">\n\n                    ";
frame = frame.push();
var t_57 = env.getFilter("slice").call(context, l_slugs,3);
if(t_57) {var t_56 = t_57.length;
for(var t_55=0; t_55 < t_57.length; t_55++) {
var t_58 = t_57[t_55];
frame.set("slicedSlugs", t_58);
frame.set("loop.index", t_55 + 1);
frame.set("loop.index0", t_55);
frame.set("loop.revindex", t_56 - t_55);
frame.set("loop.revindex0", t_56 - t_55 - 1);
frame.set("loop.first", t_55 === 0);
frame.set("loop.last", t_55 === t_56 - 1);
frame.set("loop.length", t_56);
t_50 += "<div class=\"g-super-navigation__category-column\">\n\n                            <div class=\"c-super-navigation__inner\">\n\n                                ";
t_50 += runtime.suppressValue((lineno = 196, colno = 51, runtime.callWrap(macro_t_17, "mainNavigationTree", context, [t_58,l_tertiaryLimit,l_seeMore,runtime.contextOrFrameLookup(context, frame, "False"),runtime.makeKeywordArgs({"level": l_level + 1,"selectedLevel1Slug": runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_50 += "\n\n                            </div>\n\n                        </div>";
;
}
}
frame = frame.pop();
if(runtime.contextOrFrameLookup(context, frame, "hasFeatureColumn")) {
t_50 += "\n                        <div class=\"g-super-navigation__feature-column\">\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "promoEntry")) {
t_50 += "\n                            ";
var t_59;
t_59 = "promo | " + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promoEntry")),"slug");
frame.set("gaLabel", t_59, true);
if(frame.topLevel) {
context.setVariable("gaLabel", t_59);
}
if(frame.topLevel) {
context.addExport("gaLabel", t_59);
}
t_50 += "\n                            <div ";
t_50 += runtime.suppressValue((lineno = 209, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 209, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + l_level + "" + " click",runtime.contextOrFrameLookup(context, frame, "gaLabel")])), env.opts.autoescape);
t_50 += "\n                                 class=\"c-super-navigation__promo\" data-qa-supernav-content>\n\n                                ";
t_50 += "\n                                ";
t_50 += runtime.suppressValue((lineno = 213, colno = 44, runtime.callWrap(t_12, "renderPromo", context, [runtime.contextOrFrameLookup(context, frame, "promoEntry"),runtime.makeKeywordArgs({"classes": "js-supernav-promo"})])), env.opts.autoescape);
t_50 += "\n\n                            </div>\n                            ";
;
}
else {
if(l_featureSlug) {
t_50 += "\n                                <div class=\"c-super-navigation__feature\">\n                                    ";
t_50 += runtime.suppressValue((lineno = 218, colno = 55, runtime.callWrap(macro_t_17, "mainNavigationTree", context, [[l_featureSlug],l_tertiaryLimit,l_seeMore,runtime.contextOrFrameLookup(context, frame, "False"),runtime.makeKeywordArgs({"level": l_level + 1,"selectedLevel1Slug": runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_50 += "\n                                </div>\n                            ";
;
}
;
}
t_50 += "\n\n                        </div>\n                    ";
;
}
t_50 += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_50);
});
context.addExport("superNavigation");
context.setVariable("superNavigation", macro_t_49);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/super-navigation-macro.j2"] , dependencies)